const pageNameKey = "otaRequestApprovalForAdmin";

export const otaRequestApprovalForAdminEn = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName} Request for Approval",
    titleTemplateBackup: "Backup {itemName} Request for Approval",
    descriptionTemplateFirmware:
      "The Technician {initiator} requests to push a new firmware to this machine.",
    descriptionTemplateBackup:
      "The Technician {initiator} requests to push a new backup to this machine.",
    reviewAndApproveButtonText: "Review Request and Approve",
    cancelRequestButtonText: "Cancel Request",
    cancelSuccessMessage: "Installation request canceled successfully",
    cancelFailureMessage: "Failed to cancel installation request",
  },
};

export const otaRequestApprovalForAdminPtBr = {
  [pageNameKey]: {
    titleTemplateFirmware: "Solicitacao de aprovacao do firmware {itemName}",
    titleTemplateBackup: "Solicitacao de aprovacao do backup {itemName}",
    descriptionTemplateFirmware:
      "O tecnico {initiator} solicita enviar um novo firmware para esta maquina.",
    descriptionTemplateBackup:
      "O tecnico {initiator} solicita enviar um novo backup para esta maquina.",
    reviewAndApproveButtonText: "Revisar solicitacao e aprovar",
    cancelRequestButtonText: "Cancelar solicitacao",
    cancelSuccessMessage: "Solicitação de instalação cancelada com sucesso",
    cancelFailureMessage: "Falha ao cancelar a solicitação de instalação",
  },
};

export const otaRequestApprovalForAdminDe = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: Anfrage zur Genehmigung",
    titleTemplateBackup: "Backup {itemName}: Anfrage zur Genehmigung",
    descriptionTemplateFirmware:
      "Der Techniker {initiator} beantragt, eine neue Firmware auf diese Maschine zu uebertragen.",
    descriptionTemplateBackup:
      "Der Techniker {initiator} beantragt, ein neues Backup auf diese Maschine zu uebertragen.",
    reviewAndApproveButtonText: "Anfrage pruefen und genehmigen",
    cancelRequestButtonText: "Anfrage abbrechen",
    cancelSuccessMessage: "Installationsanfrage erfolgreich abgebrochen",
    cancelFailureMessage:
      "Installationsanfrage konnte nicht abgebrochen werden",
  },
};

export const otaRequestApprovalForAdminZhHans = {
  [pageNameKey]: {
    titleTemplateFirmware: "固件 {itemName} 请求批准",
    titleTemplateBackup: "备份 {itemName} 请求批准",
    descriptionTemplateFirmware:
      "技术人员 {initiator} 请求向此机器推送新的固件。",
    descriptionTemplateBackup: "技术人员 {initiator} 请求向此机器推送新的备份。",
    reviewAndApproveButtonText: "审核并批准请求",
    cancelRequestButtonText: "取消请求",
    cancelSuccessMessage: "安装请求已成功取消",
    cancelFailureMessage: "取消安装请求失败",
  },
};

export const otaRequestApprovalForAdminIt = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: richiesta di approvazione",
    titleTemplateBackup: "Backup {itemName}: richiesta di approvazione",
    descriptionTemplateFirmware:
      "Il tecnico {initiator} richiede di inviare un nuovo firmware a questa macchina.",
    descriptionTemplateBackup:
      "Il tecnico {initiator} richiede di inviare un nuovo backup a questa macchina.",
    reviewAndApproveButtonText: "Rivedi richiesta e approva",
    cancelRequestButtonText: "Annulla richiesta",
    cancelSuccessMessage: "Richiesta di installazione annullata con successo",
    cancelFailureMessage: "Impossibile annullare la richiesta di installazione",
  },
};

export const otaRequestApprovalForAdminEs = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: solicitud de aprobacion",
    titleTemplateBackup: "Respaldo {itemName}: solicitud de aprobacion",
    descriptionTemplateFirmware:
      "El tecnico {initiator} solicita enviar un nuevo firmware a esta maquina.",
    descriptionTemplateBackup:
      "El tecnico {initiator} solicita enviar un nuevo respaldo a esta maquina.",
    reviewAndApproveButtonText: "Revisar solicitud y aprobar",
    cancelRequestButtonText: "Cancelar solicitud",
    cancelSuccessMessage: "Solicitud de instalación cancelada correctamente",
    cancelFailureMessage: "No se pudo cancelar la solicitud de instalación",
  },
};

export const otaRequestApprovalForAdminNl = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: verzoek om goedkeuring",
    titleTemplateBackup: "Back-up {itemName}: verzoek om goedkeuring",
    descriptionTemplateFirmware:
      "De technicus {initiator} vraagt om nieuwe firmware naar deze machine te pushen.",
    descriptionTemplateBackup:
      "De technicus {initiator} vraagt om een nieuwe back-up naar deze machine te pushen.",
    reviewAndApproveButtonText: "Verzoek beoordelen en goedkeuren",
    cancelRequestButtonText: "Verzoek annuleren",
    cancelSuccessMessage: "Installatieverzoek succesvol geannuleerd",
    cancelFailureMessage: "Installatieverzoek kon niet worden geannuleerd",
  },
};

export const otaRequestApprovalForAdminTr = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName} Onay Talebi",
    titleTemplateBackup: "Yedekleme {itemName} Onay Talebi",
    descriptionTemplateFirmware:
      "Teknisyen {initiator} bu makineye yeni bir ürün yazılımı aktarmayı talep ediyor.",
    descriptionTemplateBackup:
      "Teknisyen {initiator} bu makineye yeni bir yedek göndermeyi talep ediyor.",
    reviewAndApproveButtonText: "İsteği İncele ve Onayla",
    cancelRequestButtonText: "İsteği İptal Et",
    cancelSuccessMessage: "Yükleme isteği başarıyla iptal edildi",
    cancelFailureMessage: "Yükleme isteği iptal edilemedi",
  },
};
